export type NeedId = 'llc' | 'identidad' | 'web' | 'digital' | 'todo' | 'orientacion'

export interface NeedOption {
  id: NeedId
  label: string
}

export const NEED_OPTIONS: NeedOption[] = [
  { id: 'llc', label: 'Crear mi LLC' },
  { id: 'identidad', label: 'Logo / identidad' },
  { id: 'web', label: 'Página web' },
  { id: 'digital', label: 'Presencia digital' },
  { id: 'todo', label: 'Todo lo anterior' },
  { id: 'orientacion', label: 'Necesito orientación' },
]

export interface LeadFormValues {
  nombre: string
  email: string
  telefono: string
  florida: string
  etapa: string
  necesidades: NeedId[]
  mensaje: string
}
